import { REFERENCE_MODE, RESUME_SECTION_TYPES } from "../editor/config";

export const DUMMY_SECTIONS = [
  { id: "personalInfo", type: RESUME_SECTION_TYPES.PERSONAL_INFO },
  { id: "professionalSummary", type: RESUME_SECTION_TYPES.SUMMARY },
  { id: "experiences", type: RESUME_SECTION_TYPES.EXPERIENCE },
  { id: "educations", type: RESUME_SECTION_TYPES.EDUCATION },
  { id: "skills", type: RESUME_SECTION_TYPES.SKILLS },
  { id: "projects", type: RESUME_SECTION_TYPES.PROJECTS },
  { id: "certifications", type: RESUME_SECTION_TYPES.CERTIFICATIONS },
  { id: "achievements", type: RESUME_SECTION_TYPES.ACHIEVEMENTS },
  { id: "languages", type: RESUME_SECTION_TYPES.LANGUAGES },
  { id: "interests", type: RESUME_SECTION_TYPES.INTERESTS },
  // { id: "publications", type: RESUME_SECTION_TYPES.PUBLICATIONS },
  // { id: "references", type: RESUME_SECTION_TYPES.REFERENCES },
  // { id: "volunteer", type: RESUME_SECTION_TYPES.VOLUNTEER },
];

export const DUMMY_DATA = {
  personalInfo: {
    fullName: "Jane Doe",
    headline: "Senior Software Engineer",
    email: "jane.doe@example.com",
    phone: "+1 (555) 123-4567",
    city: "Austin",
    state: "TX",
    country: "USA",
    postalCode: "78701",
    socialLinks: [
      { type: "linkedin", url: "https://linkedin.com/in/janedoe" },
      { type: "portfolio", url: "https://janedoe.dev" },
      { type: "github", url: "https://github.com/janedoe" },
    ],
    // dateOfBirth: "",
    // nationality: "American",
    // workAuthorization: "US Citizen",
    // addressLine: "200 Congress Ave, Apt 4B",
  },
  professionalSummary:
    "Senior backend engineer with 8+ years building distributed systems on AWS and Kubernetes. Track record shipping high-throughput APIs (>50k RPS) and leading small platform teams. Passionate about reliability engineering, clean architecture, and mentoring.",

  experiences: [
    {
      id: "exp-1",
      company: "Acme Cloud",
      role: "Senior Software Engineer",
      employmentType: "Full-time",
      location: "Austin, TX",
      startDate: "2022-03",
      endDate: "",
      current: true,
      // domain: "Cloud infrastructure",
      // techStack: ["Java", "Kafka", "Flink", "Kubernetes", "AWS"],
      responsibilities: [
        "Designed and shipped a multi-tenant ingestion pipeline processing 1.2B events/day on Kafka + Flink, reducing infra spend 35%.",
        "Led migration of legacy monolith to event-driven microservices across 6 squads.",
        "Mentored 4 mid-level engineers; ran weekly architecture review sessions.",
      ],
    },
    {
      id: "exp-2",
      company: "BrightApp",
      role: "Software Engineer",
      employmentType: "Full-time",
      location: "Remote",
      startDate: "2019-06",
      endDate: "2022-02",
      current: false,
      domain: "Billing / payments",
      techStack: ["Go", "PostgreSQL", "Redis", "GCP"],
      responsibilities: [
        "Built core billing service handling 8M monthly invoices with idempotent retries and exactly-once semantics.",
        "Reduced p95 checkout latency from 1.8s to 240ms via async pre-warming and DB read-replica routing.",
      ],
    },
    {
      id: "exp-3",
      company: "Nimbus Labs",
      role: "Backend Engineer (Intern → Full-time)",
      employmentType: "Internship",
      location: "Seattle, WA",
      startDate: "2017-07",
      endDate: "2019-05",
      current: false,
      domain: "Identity & access",
      techStack: ["Java", "Spring", "OAuth2", "SAML"],
      responsibilities: [
        "Implemented OAuth2 + SAML SSO for enterprise customers; first dev to ship SOC2-ready audit logging.",
      ],
    },
  ],
  educations: [
    {
      id: "edu-1",
      institution: "University of Washington",
      degree: "B.S.",
      specialization: "Computer Science",
      startDate: "2013-09",
      endDate: "2017-06",
      gpa: "3.8 / 4.0",
      location: "Seattle, WA",
      normalizedLevelOfDegree: "",
      honors: ["Magna Cum Laude", "Dean's List (4 semesters)"],
      // activities: ["ACM Programming Team", "Women in CS — Co-chair"],
      coursework: [
        "Distributed Systems",
        "Operating Systems",
        "Compilers",
        "Algorithms",
      ],
    },
  ],
  skills: {
    technicalSkills: [
      "Java",
      "Go",
      "Python",
      "Kubernetes",
      "AWS",
      "Kafka",
      "PostgreSQL",
      "Redis",
      "Terraform",
    ],
    softSkills: ["Mentoring", "Technical writing", "Cross-team collaboration"],
  },
  projects: [
    {
      id: "proj-1",
      name: "OpenInbox",
      sourceUrl: "https://github.com/janedoe/openinbox",
      description:
        "Open-source self-hosted email aggregator (3k+ GitHub stars).",
      startDate: "2021-04",
      endDate: "",
      current: true,
      highlights: [
        "Designed IMAP poller with deduplication and exponential backoff.",
        "Built React dashboard with virtualized 100k-row inbox view.",
      ],
    },
  ],
  certifications: [
    {
      id: "cert-1",
      name: "AWS Solutions Architect — Professional",
      issuer: "Amazon Web Services",
      issueDate: "2024-04",
      expirationDate: "2027-04",
      credentialId: "AWS-SAP-2024-12345",
      credentialUrl: "https://aws.amazon.com/verification/janedoe",
    },
    {
      id: "cert-2",
      name: "Certified Kubernetes Administrator (CKA)",
      issuer: "CNCF",
      issueDate: "2023-09",
      expirationDate: "2026-09",
      credentialId: "",
      credentialUrl: "",
    },
  ],
  languages: [
    { id: "lang-1", language: "English", proficiency: "Native" },
    { id: "lang-2", language: "Spanish", proficiency: "Conversational" },
  ],
  achievements: [
    {
      id: "ach-1",
      title: "ICPC Regional Finalist",
      date: "2016-11",
      description:
        "Reached the North America regional finals representing UW (ranked 8th of 142 teams).",
    },
    {
      id: "ach-2",
      title: "Internal Hackathon Winner — Acme Cloud",
      date: "2023-06",
      description:
        "Won 1st place across 38 teams with a prototype real-time anomaly detector.",
    },
  ],
  interests: [
    "Long-distance trail running",
    "Mechanical keyboards",
    "Modern Korean fiction",
  ],
  // "publications": {
  //   items: [
  //     {
  //       id: "pub-1",
  //       title: "Scaling Event Ingestion to a Billion Events Per Day",
  //       publisher: "Acme Engineering Blog",
  //       date: "2024-02",
  //       url: "https://eng.acme.cloud/scaling-ingestion",
  //       authors: "Jane Doe, Ravi Kumar",
  //       description:
  //         "Technical deep-dive on the multi-tenant Kafka + Flink architecture.",
  //     },
  //   ],
  // },
  // "references": {
  //   mode: REFERENCE_MODE.AVAILABLE_ON_REQUEST,
  //   items: [],
  // },
  // "volunteer": {
  //   items: [
  //     {
  //       id: "vol-1",
  //       organization: "Girls Who Code — Austin Chapter",
  //       role: "Volunteer Mentor",
  //       location: "Austin, TX",
  //       startDate: "2022-09",
  //       endDate: "",
  //       current: true,
  //       highlights: [
  //         "Mentor 6 high-school students weekly on intro programming and career paths.",
  //         "Designed a 10-week Python curriculum used across two chapters.",
  //       ],
  //     },
  //   ],
  // },
};
